// extracted by mini-css-extract-plugin
module.exports = {"indicators":"Indicators_indicators__YY_et","indicators__item":"Indicators_indicators__item__QWmoT","indicators__item--active":"Indicators_indicators__item--active__rckU2"};